import * as React from 'react';

export interface ISpinnerProps {
  isOverlay?: boolean;
}

export const SpinnerRing = () => (
  <div className='lds-ring' aria-hidden="true">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export const Spinner = ({ isOverlay = false }: ISpinnerProps) =>
  isOverlay ? (
    <div className='lds-overlay'>
      <SpinnerRing />
    </div>
  ) : (
    <SpinnerRing />
  );
